import type { z } from 'zod';
import { attachmentSchema } from '@/entities/shared/attachment/attachment';
import { isoDateField } from '@/entities/shared/schemas/iso-date-field';
import { longTextField } from '@/entities/shared/schemas/long-text-field';
import { nameField } from '@/entities/shared/schemas/name-field';
import { shortTextField } from '@/entities/shared/schemas/short-text-field';
import { zs } from '@/entities/shared/schemas/zod';
import { documentCategorySchema } from './document-category';

/** A copy of a document, with its files available offline. Mirrors …/collections/document.py. */
export const kitDocumentSchema = zs.looseObject({
  title: nameField,
  category: documentCategorySchema.default('other'),
  holder: shortTextField.optional(),
  issued_on: isoDateField.optional(),
  expires_on: isoDateField.optional(),
  /** Days before `expires_on` to start warning; absent: 90 (decision 0012). */
  remind_days: zs.number().int().min(0).max(730).optional(),
  original_location: shortTextField.optional(),
  notes: longTextField.optional(),
  attachments: zs.array(attachmentSchema).default([]),
});

export type KitDocument = z.infer<typeof kitDocumentSchema>;
